var render = function render(){var _vm=this,_c=_vm._self._c;return (this.$store.getters.auth.isAdmin)?_c('AbstractRouteFilters',{attrs:{"filters":_vm.filters,"on-click":_vm.navigate}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }